import { RocketOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { Col, Row, Select, Table, Tooltip, Typography } from "antd/es";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ShippingModal from "./ShippingModal";
import { getQueryParams, generateQuery } from "modules/utilities/utility";
// import { shippingPendingOrders } from "../services";
import DownloadShippingPending from "./DownloadShippingPending";
import ReactDatePicker from "react-datepicker";
import { useShippingPending } from "modules/misc_orders/store";
import CardDiv from "modules/common/card-div/CardDiv";

const { Title } = Typography;

const ShippingPendingOrders = () => {
  const history = useNavigate();
  const [orders, setOrders] = useState([]);
  const [caseId, setCaseId] = useState([]);
  const [orderId, setOrderId] = useState([]);
  const [filter, setFilter] = useState(getQueryParams("filter") || "all");
  const [loading, setLoading] = useState(false);
  const [sd, setSd] = useState("");
  const [ed, setEd] = useState("");
  const [page, setPage] = useState(parseInt(getQueryParams("page")) || 1);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { flaggedOrders, shippingPendingOrders } = useShippingPending();

  useEffect(() => {
    setOrders(flaggedOrders);
  }, [flaggedOrders]);

  useEffect(() => {
    const filterItems = [{ page, filter }];
    history({ search: generateQuery(filterItems) });
  }, [filter, history, page]);

  useEffect(() => {
    if (getQueryParams("sd")) setSd(moment(getQueryParams("sd")));
    if (getQueryParams("ed")) setEd(moment(getQueryParams("ed")));
  }, []);

  const handleShippindModal = (record) => {
    setIsModalVisible(true);
    setCaseId(record.case_id);
    setOrderId(record.order_id);
  };

  const handleTableChange = (page, filter) => {
    setPage(page.current);
  };
  const columns = [
    {
      title: "Order Id",
      dataIndex: "order_display_id",
      key: "order_display_id",
      render: (value, record) => (
        <div>
          <Link className="link" to={`/lead-details/${record.case_id}`}>
            {value}
          </Link>
        </div>
      ),
    },
    {
      title: "Order Date",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
      render: (value) => moment(value).format("DD-MM-YYYY"),
    },
    {
      title: "Order Status",
      dataIndex: "status",
      key: "order_status",
    },
    {
      title: "Order warehouse",
      dataIndex: "warehouseName",
      key: "warehouseName",
    },
    {
      title: "Location Pending",
      dataIndex: "is_location_pending",
      key: "is_location_pending",
      width: "10%",
      render: (value) => value && "True",
    },
    {
      title: "Location Pending Reason",
      dataIndex: "is_location_pending_reason",
      key: "is_location_pending_reason",
      ellipsis: true,
      width: "10%",
      render: (value) => {
        return value ? <Tooltip title={value}>{value}</Tooltip> : "N/a";
      },
    },
    {
      title: "Mark Shipped",
      key: "markShippedModal",
      width: "10%",
      render: (value, record) => (
        <Button
          icon={<RocketOutlined />}
          type="link"
          onClick={() => handleShippindModal(record)}
          style={{
            border: "1px solid #628d12",
            borderRadius: "50%",
            padding: "0 1px",
          }}
        />
      ),
    },
  ];

  const _getShippingPendingOrders = useCallback(
    async (sd, ed) => {
      let _sd = null;
      let _ed = null;
      setLoading(true);
      if (!(!sd || sd === "" || ed === "" || !ed)) {
        _sd = moment(sd).format("YYYY-MM-DD");
        _ed = moment(ed).format("YYYY-MM-DD");
      }
      const res = await shippingPendingOrders(page, _sd, _ed, filter);
      //   if (res) setOrders(res);
      setLoading(false);
    },
    [filter, page]
  );

  const handleDateFilter = async () => {
    await _getShippingPendingOrders(sd, ed);
  };

  const refreshUi = async () => {
    let _sd = null;
    let _ed = null;
    setLoading(true);
    if (!(!sd || sd === "" || ed === "" || !ed)) {
      _sd = moment(sd).format("YYYY-MM-DD");
      _ed = moment(ed).format("YYYY-MM-DD");
    }
    const res = await shippingPendingOrders(1, _sd, _ed, filter);
    // if (res) setOrders(res);
    setLoading(false);
  };

  useEffect(() => {
    _getShippingPendingOrders(sd, ed);
  }, [_getShippingPendingOrders, ed, sd]);

  return (
    <div className="pt-4">
      <CardDiv
        title={
          <div className="d-flex justify-content-between align-items-center">
            <div style={{ alignItems: "center", display: "flex" }}>
              <h4 style={{ marginLeft: 0, whiteSpace: 'nowrap', marginRight: '4px' }}>
                Orders Pending to be shipped
              </h4>
              <DownloadShippingPending
                data={orders?.data}
                type="pending-to-shipped"
              />
            </div>

            <div style={{ display: "flex" ,width:"700px"}}>
              
                <ReactDatePicker

                  selected={sd}
                  onChange={(date) => setSd(date)}
                  formatWeekDay={(day) => day.slice(0, 3)}
                  className="form-control"
                  placeholderText="Start Date"
                />
                <ReactDatePicker
                  selected={ed}
                  onChange={(date) => setEd(date)}
                  formatWeekDay={(day) => day.slice(0, 3)}
                  className="form-control"
                  placeholderText="End Date"
                />
              <Button
                type="primary"
                disabled={!sd || !ed}
                onClick={handleDateFilter}
                style={{ marginLeft: "1%" }}
              >
                Submit
              </Button>
              <Col span={8} style={{ marginLeft: "2%" }}>
                <Select
                  dropdownMatchSelectWidth
                  value={filter}
                  style={{ width: "100%" }}
                  placeholder="Filters"
                  options={filterOptions}
                  onChange={setFilter}
                />
              </Col>
            </div>
          </div>
        }
        component={
          <div style={{ minHeight: "70vh", maxHeight: "75vh", zIndex: "-1" }}>
            <ShippingModal
              caseId={caseId}
              orderId={orderId}
              isModalVisible={isModalVisible}
              setModalVisible={setIsModalVisible}
              refreshUi={refreshUi}
            />

            <div
              className="shadow table-row rounded-bottom scrollable-container"
              style={{
                fontSize: 13.2,
              }}
            >
              <div className="rounded-bottom">
                <Table
                  columns={columns}
                  onChange={(page, filter, sort) =>
                    handleTableChange(page, filter, sort)
                  }
                  loading={loading}
                  dataSource={orders?.data || []}
                  style={{ width: "100%", zIndex: "0" }}
                  pagination={{
                    current: page,
                    showSizeChanger: false,
                    pageSize: 10,
                    total: orders?.pagination?.rowCount || 1,
                  }}
                  scroll={{ y: 380 }}
                />
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
};

const filterOptions = [
  { value: "all", label: "All" },
  { value: "delivered", label: "Delivered and warehouse not updated" },
  { value: "not-delivered", label: "Not delivered and warehouse not updated" },
  { value: "all-updated", label: "Warehouse updated" },
];
export default ShippingPendingOrders;
